import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownContainer } from "./styles";

const termsMarkdown = `# 서비스 이용약관

## 제1장 총칙

### 제1조 (목적)
본 약관은 주식회사 마고(이하 "회사")가 제공하는 AI API 도입 플랫폼 "Audion"(이하 "서비스")의 이용과 관련하여 회사와 회원 간의 권리, 의무, 책임 및 기타 필요한 사항을 규정함을 목적으로 합니다.

### 제2조 (용어의 정의)
본 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. "서비스"라 함은 음성 AI 기술을 기반으로 회사가 제공하는 '오디온' 플랫폼 및 관련 제반 서비스를 의미합니다.
2. "회원"이라 함은 본 약관에 따라 회사와 이용계약을 체결하고 회사가 제공하는 서비스를 이용하는 고객을 의미합니다.
3. "API" (Application Programming Interface)라 함은 서비스의 특정 기능이나 데이터를 회원의 시스템에서 활용할 수 있도록 제공되는 인터페이스를 의미합니다.
4. "SDK" (Software Development Kit)라 함은 회원이 서비스의 API를 용이하게 활용할 수 있도록 제공되는 개발 도구를 의미합니다.
5. "음성 AI 에이전트"라 함은 음성 인식, 음성 이해, 감정 인식, 대화 모델 등을 포함하여 음성 데이터를 처리하고 상호작용하는 AI 기반의 솔루션을 의미합니다.
6. "유료 서비스"라 함은 회사가 제공하는 서비스 중 회사가 별도로 정한 이용요금을 지불해야만 이용할 수 있는 서비스를 의미합니다.
7. "콘텐츠"라 함은 회원이 서비스를 이용하여 생성, 업로드, 저장하는 음성 파일, 텍스트 변환 기록, 분석 결과물(요약, 감정 인식 결과 등) 및 기타 모든 데이터 또는 정보를 의미합니다.

본 약관에서 사용하는 용어의 정의는 본 조에서 정하는 것을 제외하고는 관련 법령 및 상관례에 따릅니다.

### 제3조 (약관의 효력 및 변경)
1. 본 약관은 서비스 웹사이트(audion.magovoice.com)에 게시하거나 기타의 방법으로 회원에게 공지함으로써 효력이 발생합니다.
2. 회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」, 「약관의 규제에 관한 법률」 등 관련 법령을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
3. 회사가 약관을 개정할 경우, 적용일자와 개정 사유를 명시하여 현행 약관과 함께 서비스 웹사이트 내 연결 화면에 그 적용일자 7일 전부터 적용일자 이후 상당 기간 동안 공지합니다. 다만, 회원에게 불리한 약관 개정의 경우에는 적용일자 30일 전부터 공지하며, 이메일, 로그인 시 동의창 등의 전자적 수단을 통해 명확히 통지하도록 합니다.
4. 회원이 개정 약관 공지 시점부터 적용일자까지 거부 의사를 표시하지 않으면 개정 약관에 동의한 것으로 간주하며, 이 경우 회원은 개정 약관의 적용을 받습니다. 회원이 개정 약관에 동의하지 않는 경우 회원은 서비스 이용계약을 해지할 수 있습니다.
5. 개정 약관은 적용일자 이후에 체결되는 계약에만 적용되고, 그 이전에 체결된 계약에 대해서는 개정 전의 약관 조항이 적용됩니다.
6. 본 약관에서 정하지 아니한 사항과 약관의 해석에 관하여는 「전자상거래 등에서의 소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」, 「공정거래위원회가 정하는 전자상거래 등에서의 소비자 보호지침」 및 관계 법령 또는 상관례에 따릅니다.

### 제4조 (회원가입)
1. 회사에서 제공하는 서비스를 이용하려는 가입 신청자는 본 약관에 동의하고, 회사가 요구하는 신원 정보를 제공함으로써 회원가입 계약을 체결할 수 있습니다.
2. 회원가입을 위해서는 다음 각 호의 개인정보를 제공해야 합니다.
   - 회원의 전자우편 주소
   - 회원이 설정한 비밀번호
   - 서비스 이용에 필요한 회원이 설정한 닉네임
   - 회사가 필요하다고 인정하는 기타 사항
3. 회사가 회원가입 신청을 승낙한 시점에 회원가입 계약이 성립됩니다.

## 제2장 이용계약 및 회원관리

### 제5조 (이용계약 등의 체결)
1. 회사는 가입 신청자의 서비스 이용 신청을 승인하는 것을 원칙으로 하나, 다음 각 호의 경우에는 승인을 유보하거나 거절할 수 있습니다.
   1. 가입 신청자가 회사가 요구하는 내용을 기재하지 않거나, 허위의 정보를 기재한 경우
   2. 가입 신청자가 이전에 회원 자격을 상실한 적이 있는 경우
   3. 기타 관련 법령에 위배되거나 회사가 정한 기준에 반하는 경우
2. 회사가 회원가입 신청을 승인하지 않거나 유보할 경우, 가입 신청자에게 관련 내용을 알립니다.
3. 회사는 서비스 정책에 따라 회원의 등급을 구분하여 서비스 메뉴, 이용 시간, 이용 횟수 등을 다르게 제공할 수 있습니다.
4. 회원은 서비스의 개인정보 관리 화면을 통해 자신의 개인정보를 언제든지 열람하고 수정할 수 있습니다.
5. 서비스 이용을 위한 아이디와 비밀번호 등 개인정보의 관리 책임은 회원에게 있으며, 회원은 자신의 개인정보를 제3자가 이용하도록 해서는 안 됩니다.

## 제3장 서비스 이용 및 운영

### 제6조 (서비스의 종류)
회사는 회원에게 다음과 같은 서비스를 제공합니다.

1. **음성 텍스트 변환 및 대화 분석 기능:**
   - 실시간 음성 텍스트 변환 기능
   - 음성 파일 업로드 및 고품질 텍스트 변환 기능
   - 음원 구성 요소 분석 및 텍스트 추출
   - 결과물 대화 단위 분리 및 화자별 분리
   - 음성 내 감정 분석 기능
   - 핵심 키워드 추출 및 요약

2. **음성 AI 커스터마이징 기능:**
   - 제1항에 나열된 요소 기술을 활용한 고객 맞춤형 기술 제작 기능 (나만의 음성 AI)

3. **정보 탐색 및 관리 기능:**
   - 음성만으로 중요한 내용을 탐색하는 보이스 하이라이트 기능
   - **콘텐츠 생성 및 저장 기능:** 음성 파일 업로드 및 분석을 통해 텍스트 변환 기록, 요약, 감정 분석 결과 등 콘텐츠를 생성하고 저장할 수 있습니다.
   - **콘텐츠 관리 및 삭제 기능:** 생성된 콘텐츠를 관리하고, 더 이상 필요하지 않은 콘텐츠를 삭제할 수 있습니다.

4. **연동 및 도입 편의 기능:**
   - API 및 SDK를 활용한 서비스 연동 기능
   - 웹 환경에서 SaaS처럼 테스트 가능한 플레이그라운드 기능

5. 서비스는 필요한 경우에 서비스의 기능이나 종류를 수정 또는 추가할 수 있습니다. 이러한 경우에 관련 내용을 사전에 회원에게 공지하거나 게시합니다.

### 제7조 (유료 서비스 및 결제)
1. 회사는 서비스의 일부 또는 전체에 대하여 유료 서비스를 제공할 수 있으며, 회원은 유료 서비스 이용을 위하여 회사가 정한 이용요금을 지불해야 합니다.
2. 유료 서비스의 종류, 가격, 결제 방법 등 구체적인 사항은 서비스 웹사이트(audion.magovoice.com) 또는 서비스 내 별도의 화면을 통해 명확하게 게시됩니다. 서비스의 범위, 내용 및 이용요금 관련 제반 사항은 회사의 정책에 따라 변경될 수 있으며, 변경 시에는 제3조(약관의 효력 및 변경)에 따라 회원에게 공지합니다.
3. 회원은 유료 서비스 결제 시 본인이 제공하는 정보(카드 정보, 계좌 정보 등)가 정확하고 유효한 정보임을 확인해야 하며, 해당 정보의 오류 또는 미제공으로 인해 발생하는 책임과 불이익은 전적으로 회원이 부담합니다.
4. 회원이 회사가 청구한 유료 서비스 이용요금을 납부 기한 내에 납부하지 않을 경우, 회사는 서비스 이용을 제한하거나 중지할 수 있습니다. 이로 인해 발생할 수 있는 회원의 데이터 손실 또는 기타 불이익에 대한 책임은 회원에게 있습니다.

## 제4장 계약당사자의 의무

### 제8조 (개인정보보호)
1. 회사는 관련 법령이 정하는 바에 따라 회원의 개인정보보호를 위해 "개인정보처리방침"을 수립하고 회원에게 고지합니다.
2. 회사는 필요한 범위 내에서 최소한의 개인정보를 수집하며, 회원이 동의한 목적과 범위 내에서만 사용합니다. 회사는 서비스 제공을 위해 새로운 이용 목적이 발생하거나 제3자에게 제공하는 경우 회원에게 이용 및 제공 단계에 관련 내용을 고지하고 동의를 구합니다. 개인정보 수집, 이용, 제공에 관한 회원의 동의 거절 시, 제한되는 서비스를 구체적으로 명시합니다.
3. 개인정보 보호를 위해 회사에서 개인정보를 취급하는 인원을 최소한으로 제한하며, 이용자의 개인정보 분실, 도난, 유출, 변조 등을 방지하고자 책임을 다합니다.
4. 회원은 회사에 자신의 개인정보에 대한 열람 및 오류 정정을 언제든지 요구할 수 있습니다.
5. 회원은 서비스 이용에 필요한 자신의 개인정보를 관리할 책임이 있으며 이를 외부에 노출하거나 제3자가 이용하도록 권한을 양도해서는 안 됩니다.
6. 회원은 개인정보가 도용되었거나 제3자가 사용하고 있음을 인지한 경우, 즉시 관련 사실을 회사에 통지하고 회사의 조치를 따라야 합니다.

### 제9조 (회사의 의무)
1. 회사는 회원이 안전하게 서비스를 이용할 수 있도록 보안 시스템을 갖추며 회원의 개인정보 보호에 최선을 다합니다.
2. 회사는 회원의 개인정보를 취급할 때 관련 법률 및 개인정보 보호 정책을 준수합니다. 개인정보의 수집, 이용, 보호, 제공 등에 대한 내용은 개인정보 보호 정책에서 자세히 설명하고 있습니다.
3. 회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제22조제2항이 규정한 사항에 따라 정보의 수집 및 이용 목적을 분명하게 명시합니다.
4. 회사는 회원이 서비스를 이용함에 불편이 없도록 접수된 의견이나 불만사항을 지체 없이 처리합니다.
5. 회사는 회원이 본 약관을 준수하지 않거나 부적절하게 이용하는 경우, 회원의 서비스 이용을 중단하거나 계약을 해지하는 등의 조치를 취할 수 있습니다.

### 제10조 (회원의 준수사항/이용자 권리 의무)
1. 회원은 서비스 이용 시, 본 약관에 따른 회사의 규정 및 지침을 준수해야 합니다.
2. 회원은 "오디온 서비스" 이용을 위해 휴대전화의 저장공간과 전화에 대한 접근 권한을 "회사"에게 허용해야 합니다.
3. 회원이 서비스 내에서 생성한 기록물의 저작권은 회원 본인에게 있습니다. 회원은 본 서비스를 이용함으로써 얻은 정보 및 결과에 대한 책임을 집니다. 회원이 정보에 의존함으로써 발생한 피해 및 손실에 대해서는 회사는 어떠한 책임도 지지 않습니다.
4. 회원은 본 서비스를 개인적인 용도로만 사용해야 합니다. 만약 상업적 목적 및 다른 불순한 용도로 사용할 경우, 회사는 회원의 서비스 접근 권한을 박탈하고 법적 조치를 취할 수 있습니다.
5. 회원이 기록물을 생성하고 공유하며 다음 각 호에 해당하는 행동을 취할 경우, 회사는 기록물 삭제, 회원의 서비스 이용 제한, 이용계약 해지 등의 조치를 취할 수 있습니다.
   1. 대한민국 법령을 위반하는 내용이 포함된 경우
   2. 타인의 개인정보를 훼손하거나 타인의 권리나 명예 등 이익을 침해하는 경우
   3. 타인에게 혐오감, 위해 또는 불쾌감을 주는 내용을 전송하는 경우
   4. 서비스에서 얻은 정보를 상업적으로 이용하거나 제3자에게 제공하는 경우
   5. 허위 또는 과대광고, 음란물 게시 등 불법적인 목적으로 입력물을 생성하는 경우
   6. 서비스의 원활한 진행을 방해하는 악성코드나 불법 데이터를 포함한 경우
   7. 사회 질서를 어지럽히는 내용을 포함하고 정치적, 경제적 분쟁을 야기할 경우
   8. 범죄와 관련된 내용이 포함된 경우

### 제11조 (콘텐츠의 활용 및 책임)
1. 회사는 본 약관과 개인정보처리방침에서 정한 경우를 제외하고 회원이 서비스에 기록한 미디어 파일과 관련 기록물(콘텐츠)을 제3자에게 공개하거나 제공하지 않습니다.
2. 회사는 회원의 동의를 받은 콘텐츠들을 회원에게 더 좋은 서비스를 제공하기 위해 서비스를 이용하는 과정에 입력되는 내용과 결과물(음성 녹음 파일, 텍스트로 변환된 기록, 편집된 기록, 추출 또는 입력된 키워드, 감정 인식 결과 등을 포함하며 이에 한정하지 않음)을 저장하고, 서비스 성능 향상 및 개선 목적으로 활용할 수 있습니다.
3. 서비스 성능 향상 및 개선 목적 활용에 동의한 콘텐츠의 경우, 서비스가 해지된 후에도 회원의 데이터는 개인정보와 분리되고 암호화하여 저장되며, 5년간 서비스 성능 향상 및 개선 목적으로 이용된 후 삭제됩니다.
4. 서비스 개선 목적에 동의하지 않은 경우에는 서비스 이용에 있어 일부 제한이 있거나 서비스에서 제공하는 혜택을 받지 못할 수 있습니다.
5. 서비스 개선 목적에 동의하지 않은 회원은 서비스 계약 해지를 신청하고 승인되는 시점에 모든 콘텐츠가 즉시 삭제됩니다.
6. 회원이 동의한 경우, 회사는 회원이 생성한 콘텐츠를 본질적 내용을 변경하지 않는 범위 내에서 복제, 배포, 전시 등 마케팅 등의 목적으로 활용할 수 있습니다.
7. 회사는 회원이 콘텐츠를 어떻게 생성하고 활용하는지에 대해 책임지지 않습니다.

## 제5장 서비스 이용제한 및 계약해지

### 제12조 (회원 탈퇴 및 자격 상실 등)
1. 회원이 더 이상 서비스 이용을 원하지 않을 경우, 언제든지 서비스 내 화면을 통해 회사에 탈퇴를 요청하고 이용계약을 종료할 수 있습니다. 회사는 회원이 요청한 내용을 즉시 처리할 의무가 있습니다.
2. 회원의 자발적인 이용계약 해지 시에는 개인정보는 바로 삭제되며 콘텐츠는 다시 복구할 수 없습니다.
3. 회원의 자발적 탈퇴가 아닌 다음 각 호의 경우에는 회사에서 회원의 자격을 제한하거나 정지시킬 수 있습니다.
   1. 가입 신청 시, 자신의 신원 정보가 아닌 허위 내용을 제출한 경우
   2. 음성 파일을 비롯한 타인의 개인정보를 도용하거나 배포한 경우
   3. 다른 회원의 권리나 명예 등 정당한 이익을 침해한 경우
   4. 서비스를 불법적인 목적으로 사용한 경우
   5. 서비스의 원활한 운영을 방해하는 행위를 하거나 시도한 경우
4. 회사가 회원 자격을 제한하거나 정지할 경우, 회원에게 이를 통지하고 30일간 사유가 시정되지 않으면 회원에게 회원 자격을 상실할 수 있음을 사전 통지합니다.
5. 회사가 회원 자격을 상실시킬 경우, 회원에게 이를 통지하고 7일간의 기간을 제공합니다.
6. 회사는 회원의 서비스 탈퇴 후에 부정한 이용을 방지하고자 이용계약 종료된 시점으로부터 30일간 재가입을 금지합니다.

### 제13조 (서비스의 변경, 중단)
1. 회사는 서비스의 안정적인 운영을 위해 노력합니다. 그러나 정보통신설비의 보수 점검 및 교체, 보안 문제, 무선 데이터 서비스 제공자의 네트워크 오류 및 결함 등으로 인해 서비스가 일시 중단될 수 있습니다.
2. 회사는 제1항의 사유로 서비스 제공이 일시적으로 중단되는 경우에 회원 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사의 고의 또는 중대한 과실이 없음을 입증하는 경우에 대해서는 배상하지 않으며 어떠한 책임도 지지 않습니다.
3. 회사는 서비스 안정 및 개선을 목적으로 서비스의 중단이 필요하다고 판단되는 경우, 전체 서비스나 일부 서비스를 일시적 또는 영구적으로 중단할 수 있습니다.
4. 회사는 제3항의 사유로 서비스 제공이 중단되는 경우에 서비스를 통해 관련 정보를 회원에게 사전 고지합니다.

## 제6장 기타

### 제14조 (분쟁해결)
1. 회사와 회원 간에 발생한 모든 분쟁 및 문제에 대하여 회사와 회원은 원만하게 해결하기 위한 노력을 해야 합니다.
2. 본 약관 또는 서비스와 관련하여 회사와 회원 간의 발생한 분쟁에 대하여 소송이 제기될 경우, 「민사소송법」에서 정한 절차를 따르며 회사의 본사 소재지를 관할하는 법원을 전속 관할법원으로 합니다.

### 제15조 (보장 및 면책)
1. 회사는 회원 간 또는 회원과 제3자 상호간에 서비스를 매개로 하여 발생한 거래 등에 대해서는 책임이 면제됩니다.
2. 제13조 제1항의 사유로 회사가 서비스를 일시적으로 중단하는 경우, 회사는 불가항력을 이유로 회원 또는 제3자가 입은 손해에 대하여 책임지지 않습니다. 단, 고의나 중과실로 인한 경우를 제외합니다.
3. 회사는 회원이 자신의 개인정보를 타인에게 제공하는 등 회원의 귀책사유로 인해 발생하는 피해에 대해서 일체의 책임을 지지 않습니다.

### 제16조 (약관 외 준칙)
1. 본 약관에는 대한민국 법령이 적용됩니다.
2. 회사와 회원은 본 약관상의 권리와 의무를 제3자에게 양도할 수 없습니다.
3. 회사는 필요한 경우에 본 약관을 변경할 수 있습니다. 약관이 변경되는 경우에 운영자는 변경 약관을 서비스 내에 미리 게시하여 이용자에게 알립니다.
4. 변경 약관은 게시된 시점부터 효력이 발생됩니다.

---

**부칙**  
본 약관은 2025년 8월 1일부터 시행됩니다.`;

const TermsPage: React.FC = () => {
  return (
    <MarkdownContainer>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{termsMarkdown}</ReactMarkdown>
    </MarkdownContainer>
  );
};

export default TermsPage;
